import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { useBreakPoint } from '@repo/toolkit/use-break-point'
import TranslationDropdown from '@repo/ui/translation-dropdown'
import { PropsWithChildren, useMemo } from 'react'

import useTranslate from '../../lib/hooks/use-translate'
import ClientAuthVariant from './auth-layout-variants/client-auth-variant'
import DefaultAuthVariant from './auth-layout-variants/default-auth-variant'
import StaffAuthVariant from './auth-layout-variants/staff-auth-variant'

type Props = {
  text: string
  useTranslation?: boolean
  variant?: 'default' | 'client' | 'staff'
}

const AuthLayout = ({
  text,
  useTranslation,
  variant = 'default',
  children
}: PropsWithChildren<Props>) => {
  const device = useBreakPoint()
  const isMobile = device === 'mobile'
  const { currentLanguage, i18n } = useTranslate()

  const LayoutComponent = useMemo(() => {
    switch (variant) {
      case 'default':
        return <DefaultAuthVariant text={text} />
      case 'client':
        return <ClientAuthVariant />
      case 'staff':
        return <StaffAuthVariant />
      default:
        return <DefaultAuthVariant text={text} />
    }
  }, [variant, text])

  return (
    <div className="flex justify-center items-center h-full w-full bg-primary overflow-hidden ">
      <div className="w-1/2 bg-white h-full flex justify-center items-center mobile:h-fit mobile:w-full mobile:absolute mobile:bg-opacity-0 mobile:top-64 z-50 mobile:px-6">
        {useTranslation && (
          <div className="absolute z-50 top-10 left-10 mobile:-top-56 mobile:left-auto mobile:right-5">
            <TranslationDropdown
              language={currentLanguage}
              onLanguageChange={(language) => i18n.changeLanguage(language)}
              color={isMobile ? tailwindColors.white.DEFAULT : tailwindColors.grey.DEFAULT}
            />
          </div>
        )}
        <div className="w-1/2 mobile:flex mobile:justify-start mobile:flex-col mobile:w-full ">
          {children}
        </div>
      </div>

      <div className="w-1/2 h-full relative mobile:w-full">{LayoutComponent}</div>
    </div>
  )
}

export default AuthLayout
